import { render, staticRenderFns } from "./TeamEmpty.vue?vue&type=template&id=41f985f4&scoped=true"
import script from "./TeamEmpty.vue?vue&type=script&lang=js"
export * from "./TeamEmpty.vue?vue&type=script&lang=js"
import style0 from "./TeamEmpty.vue?vue&type=style&index=0&id=41f985f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f985f4",
  null
  
)

export default component.exports